import React, { Suspense, lazy } from 'react';
import { createRoot } from 'react-dom/client';
import './styles.css';
import { Logo } from '@pmndrs/branding';
import './loader.css';

const JBAviation = lazy(() => import('./App'));

const App = () => (
  <Suspense fallback={
    <div className="loading-screen">
      <div class="loader">
        <span></span>

        <div id="dot-1" class="dot"></div>
        <div id="dot-2" class="dot"></div>
        <div id="dot-3" class="dot"></div>
        <div id="dot-4" class="dot"></div>
        <div id="dot-5" class="dot"></div>
      </div>
      <div class="loader1" style={{marginTop:'50px'}}>
        <div class="scanner">
          <span>Loading...</span>
        </div>
      </div>

    </div>
  }>
    <JBAviation />
  </Suspense>
);

createRoot(document.getElementById('root')).render(<App />);
